export default {"src":"/_next/static/media/delete_filled.44f74281.svg","height":24,"width":24};